import { CoreType } from '@apeiron/planet'
import { styled } from '@mui/material'
import IconPlusURL from '@public/icons/icon-plus.png'
import BackgroundArcaneURL from '@public/images/background-planet-arcane.png'
import BackgroundDivineURL from '@public/images/background-planet-divine.png'
import BackgroundElementalURL from '@public/images/background-planet-elemental.png'
import BackgroundMythicURL from '@public/images/background-planet-mythic.png'
import BackgroundNormalURL from '@public/images/background-planet-normal.png'
import BackgroundPrimalURL from '@public/images/background-planet-primal.png'
import TagArcaneURL from '@public/images/image-tag-arcane.png'
import TagDivineURL from '@public/images/image-tag-divine.png'
import TagElementalURL from '@public/images/image-tag-elemental.png'
import TagMythicURL from '@public/images/image-tag-mythic.png'
import TagPrimalURL from '@public/images/image-tag-primal.png'
import * as R from 'ramda'
import React from 'react'

const BACKGROUNDS = {
  [CoreType.Primal]: BackgroundPrimalURL,
  [CoreType.Divine]: BackgroundDivineURL,
  [CoreType.Arcane]: BackgroundArcaneURL,
  [CoreType.Mythic]: BackgroundMythicURL,
  [CoreType.Elemental]: BackgroundElementalURL,
  [CoreType.Normal]: BackgroundNormalURL,
  [CoreType.None]: BackgroundNormalURL
}

const TAGS = {
  [CoreType.Primal]: TagPrimalURL,
  [CoreType.Divine]: TagDivineURL,
  [CoreType.Arcane]: TagArcaneURL,
  [CoreType.Mythic]: TagMythicURL,
  [CoreType.Elemental]: TagElementalURL,
  [CoreType.Normal]: null,
  [CoreType.None]: null
}

export interface PlanetExordiumBackgroundProps {
  className?: string
  coreType?: CoreType
  iconURL?: string
  imageURL?: string
  name?: string
}

const Image = styled('svg')`
  position: relative;
  left: -20px;
  top: -5px;
  width: calc(100% + 40px);
  height: calc(100% + 5px);
`

export const PlanetExordiumBackground: React.FC<
  PlanetExordiumBackgroundProps
> = props => {
  const { className, coreType, iconURL, imageURL, name } = props

  const backgroundURL = !R.isNil(coreType)
    ? BACKGROUNDS[coreType]
    : BACKGROUNDS[CoreType.None]

  const tagURL = !R.isNil(coreType) ? TAGS[coreType] : TAGS[CoreType.None]

  return (
    <div className={className}>
      <Image viewBox='-20 -5 358 442'>
        <image href={backgroundURL.src} x={0} y={0} width={317} height={437} />
        {iconURL ? (
          <image href={iconURL} x={-7} y={-5} width={74} height={74} />
        ) : null}
        {imageURL ? (
          <image href={imageURL} x={-26} y={32} width={370} height={370}>
            {name ? (
              <>
                <title>{name}</title>
                <desc>{name}</desc>
              </>
            ) : null}
          </image>
        ) : (
          <image
            href={IconPlusURL.src}
            x={126}
            y={186}
            width={66}
            height={66}
          />
        )}
        {tagURL ? (
          <image href={tagURL.src} x={48} y={370} width={222} height={42} />
        ) : null}
      </Image>
    </div>
  )
}
